/**
 * @Author: v_jppjpeng
 * @Date: 2023-07-24 09:17:02
 * @Explain: 设置管理  - 拒绝列表
 */
import http from '../http';

const MODEL = '/settings';

export default {
  // 列表
  getList(data: { isUse: number }) {
    return http.post(`${MODEL}/game-reject-list`, data);
  },
  // 新增
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add-game-rejection`, data);
  },
  // 删除
  onDel(data: { id: number }) {
    return http.post(`${MODEL}/del-game-rejection`, data);
  },
};
